import React from "react";
import { useNavigate } from "react-router-dom";

import NutritionPage from "../components/dashboard/NutritionPage";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const NutritionRoute = () => {
  const navigate = useNavigate();
  const { athleteData } = useAuth();
  const { openNotifications } = useNotifications();

  return (
    <NutritionPage
      athleteData={athleteData}
      onNotificationsClick={openNotifications}
      onOpenStatusUpdate={() => navigate("/athlete/status-update")}
      onOpenProfile={() => navigate("/athlete/dashboard")}
    />
  );
};

export default NutritionRoute;
